module.exports = __webpack_public_path__ + "static/tools-and-weapons-c5acc7c221d00c432ef63d29475b56f5.jpg";